import React from 'react';
import AboutTemplate from './AboutTemplate';
import { platformData } from './platformData';

const VarXOmicsAbout = () => {
  return (
    <AboutTemplate 
      {...platformData.varxomics}
      platformKey="varxomics"
    />
  );
};

export default VarXOmicsAbout; 